import { Fragment,useState, useEffect } from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

const Reports = ({title, submitter }) =>{
      // similar to status, but complex query
      const [primarytransactions, setPrimarytransactions] = useState([]);
      const [selected, setSelected] = useState(null);
      const [lstOpen, setOpen] = useState([]);
      
      const getList = async function(){
      		console.log("Effect");
		try {
		    const response = await fetch(ENDPOINT+"/transactions",
		    {
		    method: 'POST',
		    headers:{'Content-Type':'application/json'},
		    body: JSON.stringify({"filters":{"ttype":"generic/jupyter","state":"success"}}),
    		    });

		    console.log(response);
        if (response.ok){
		const data = await response.json();
		console.log("Data",data)
		setPrimarytransactions(data);
        }
      } catch (err) {
            console.log('error'+err);
      }

      }

      useEffect( ()=>{getList();},[]);

   return (<><h2>Reports</h2>
<button onClick={()=>{getList();}} >Load...</button>
<DataTable value={primarytransactions} paginator
 selectionMode="single" selection={selected}
        onSelectionChange={(e) => {setSelected(e["value"]["guid"]);}}
rows={12} tableStyle={{ minWidth: '50rem' }}>
    <Column field="guid" header="GUID"></Column>
    <Column field="ttype" header="Type" ></Column>
    <Column field="state" header="State"></Column>
    
</DataTable>
</>);
};


export default Reports;
